import { EpimsBaseEntityDto } from './epim-base.dto';
export class PropertyDto extends EpimsBaseEntityDto {

    PropertyId: string;

    PropertyName: string;
    PropertyLocation: string;

   

}